/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as RfidAssignmentRouteImport } from './../routes/rfid-assignment'
import { Route as LoginRouteImport } from './../routes/login'
import { Route as DeviceRegistrationRouteImport } from './../routes/device-registration'
import { Route as ChangePasswordRouteImport } from './../routes/change-password'
import { Route as DashboardRouteImport } from './../routes/_dashboard'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as AuthCallbackRouteImport } from './../routes/auth.callback'
import { Route as DashboardSettingsRouteImport } from './../routes/_dashboard/settings'
import { Route as DashboardNotificationsRouteImport } from './../routes/_dashboard/notifications'
import { Route as DashboardLogsRouteImport } from './../routes/_dashboard/logs'
import { Route as DashboardForbiddenRouteImport } from './../routes/_dashboard/forbidden'
import { Route as DashboardDashboardRouteImport } from './../routes/_dashboard/dashboard'
import { Route as DashboardSplatRouteImport } from './../routes/_dashboard/$'
import { Route as DashboardUsersIndexRouteImport } from './../routes/_dashboard/users.index'
import { Route as DashboardStreamsIndexRouteImport } from './../routes/_dashboard/streams.index'
import { Route as DashboardRfidTagsIndexRouteImport } from './../routes/_dashboard/rfid-tags.index'
import { Route as DashboardRequestsIndexRouteImport } from './../routes/_dashboard/requests.index'
import { Route as DashboardReportsIndexRouteImport } from './../routes/_dashboard/reports.index'
import { Route as DashboardLaboratoriesIndexRouteImport } from './../routes/_dashboard/laboratories.index'
import { Route as DashboardInstitutionsIndexRouteImport } from './../routes/_dashboard/institutions.index'
import { Route as DashboardInstitutesIndexRouteImport } from './../routes/_dashboard/institutes.index'
import { Route as DashboardInstallerIndexRouteImport } from './../routes/_dashboard/installer.index'
import { Route as DashboardInstallationsIndexRouteImport } from './../routes/_dashboard/installations.index'
import { Route as DashboardGroupsIndexRouteImport } from './../routes/_dashboard/groups.index'
import { Route as DashboardDevicesIndexRouteImport } from './../routes/_dashboard/devices.index'
import { Route as DashboardCertificationsIndexRouteImport } from './../routes/_dashboard/certifications.index'
import { Route as DashboardStreamsSessionIdRouteImport } from './../routes/_dashboard/streams.$sessionId'
import { Route as DashboardRfidTagsNewRouteImport } from './../routes/_dashboard/rfid-tags.new'
import { Route as DashboardRequestsIdRouteImport } from './../routes/_dashboard/requests.$id'
import { Route as DashboardReportsNewRouteImport } from './../routes/_dashboard/reports.new'
import { Route as DashboardReportsIdRouteImport } from './../routes/_dashboard/reports.$id'
import { Route as DashboardLaboratoriesNewRouteImport } from './../routes/_dashboard/laboratories.new'
import { Route as DashboardLaboratoriesIdRouteImport } from './../routes/_dashboard/laboratories.$id'
import { Route as DashboardInstitutionsNewRouteImport } from './../routes/_dashboard/institutions.new'
import { Route as DashboardInstitutionsIdRouteImport } from './../routes/_dashboard/institutions.$id'
import { Route as DashboardInstitutesSplatRouteImport } from './../routes/_dashboard/institutes.$'
import { Route as DashboardInstallationsNewRouteImport } from './../routes/_dashboard/installations.new'
import { Route as DashboardInstallationsIdRouteImport } from './../routes/_dashboard/installations.$id'
import { Route as DashboardGroupsNewRouteImport } from './../routes/_dashboard/groups.new'
import { Route as DashboardGroupsIdRouteImport } from './../routes/_dashboard/groups.$id'
import { Route as DashboardDevicesNewRouteImport } from './../routes/_dashboard/devices.new'
import { Route as DashboardDevicesIdRouteImport } from './../routes/_dashboard/devices.$id'
import { Route as DashboardCertificationsIdRouteImport } from './../routes/_dashboard/certifications.$id'
import { Route as DashboardReportsSchedulesIndexRouteImport } from './../routes/_dashboard/reports.schedules.index'
import { Route as DashboardLaboratoriesIdIndexRouteImport } from './../routes/_dashboard/laboratories.$id.index'
import { Route as DashboardInstitutionsIdIndexRouteImport } from './../routes/_dashboard/institutions.$id.index'
import { Route as DashboardInstallerJobsIndexRouteImport } from './../routes/_dashboard/installer.jobs.index'
import { Route as DashboardInstallationsIdIndexRouteImport } from './../routes/_dashboard/installations.$id.index'
import { Route as DashboardGroupsIdIndexRouteImport } from './../routes/_dashboard/groups.$id.index'
import { Route as DashboardDevicesIdIndexRouteImport } from './../routes/_dashboard/devices.$id.index'
import { Route as DashboardCertificationsIdIndexRouteImport } from './../routes/_dashboard/certifications.$id.index'
import { Route as DashboardUsersNewTenantIdRouteImport } from './../routes/_dashboard/users.new.$tenantId'
import { Route as DashboardUsersImportTenantIdRouteImport } from './../routes/_dashboard/users.import.$tenantId'
import { Route as DashboardUsersIdTenantIdRouteImport } from './../routes/_dashboard/users.$id.$tenantId'
import { Route as DashboardLaboratoriesIdEditRouteImport } from './../routes/_dashboard/laboratories.$id.edit'
import { Route as DashboardInstitutionsIdStorageRouteImport } from './../routes/_dashboard/institutions.$id.storage'
import { Route as DashboardInstitutionsIdEditRouteImport } from './../routes/_dashboard/institutions.$id.edit'
import { Route as DashboardInstallerJobsIdRouteImport } from './../routes/_dashboard/installer.jobs.$id'
import { Route as DashboardInstallerInstallationsIdRouteImport } from './../routes/_dashboard/installer.installations.$id'
import { Route as DashboardInstallationsIdEditRouteImport } from './../routes/_dashboard/installations.$id.edit'
import { Route as DashboardGroupsIdEditRouteImport } from './../routes/_dashboard/groups.$id.edit'
import { Route as DashboardDevicesIdEditRouteImport } from './../routes/_dashboard/devices.$id.edit'
import { Route as DashboardCertificationsIdEditRouteImport } from './../routes/_dashboard/certifications.$id.edit'
import { Route as DashboardUsersIdTenantIdIndexRouteImport } from './../routes/_dashboard/users.$id.$tenantId.index'
import { Route as DashboardInstallerInstallationsIdIndexRouteImport } from './../routes/_dashboard/installer.installations.$id.index'
import { Route as DashboardUsersIdTenantIdPermissionsRouteImport } from './../routes/_dashboard/users.$id.$tenantId.permissions'
import { Route as DashboardUsersIdTenantIdMoveRouteImport } from './../routes/_dashboard/users.$id.$tenantId.move'
import { Route as DashboardUsersIdTenantIdEditRouteImport } from './../routes/_dashboard/users.$id.$tenantId.edit'
import { Route as DashboardUsersIdTenantIdCertificationsRouteImport } from './../routes/_dashboard/users.$id.$tenantId.certifications'
import { Route as DashboardReportsSchedulesIdEditRouteImport } from './../routes/_dashboard/reports.schedules.$id.edit'
import { Route as DashboardInstallerInstallationsIdSensorVerificationRouteImport } from './../routes/_dashboard/installer.installations.$id.sensor-verification'
import { Route as DashboardInstallerInstallationsIdRegistrationRouteImport } from './../routes/_dashboard/installer.installations.$id.registration'
import { Route as DashboardInstallerInstallationsIdChecklistRouteImport } from './../routes/_dashboard/installer.installations.$id.checklist'
import { Route as DashboardInstallerInstallationsIdCalibrationRouteImport } from './../routes/_dashboard/installer.installations.$id.calibration'
import { Route as DashboardInstallerInstallationsIdAirflowMonitorTestRouteImport } from './../routes/_dashboard/installer.installations.$id.airflow-monitor-test'
import { Route as DashboardUsersIdTenantIdAccessIndexRouteImport } from './../routes/_dashboard/users.$id.$tenantId.access.index'
import { Route as DashboardUsersIdTenantIdAccessNewRouteImport } from './../routes/_dashboard/users.$id.$tenantId.access.new'
import { Route as DashboardUsersIdTenantIdAccessGrantIdEditRouteImport } from './../routes/_dashboard/users.$id.$tenantId.access.$grantId.edit'

const RfidAssignmentRoute = RfidAssignmentRouteImport.update({
  id: '/rfid-assignment',
  path: '/rfid-assignment',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRegistrationRoute = DeviceRegistrationRouteImport.update({
  id: '/device-registration',
  path: '/device-registration',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLogsRoute = DashboardLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardForbiddenRoute = DashboardForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSplatRoute = DashboardSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardStreamsIndexRoute = DashboardStreamsIndexRouteImport.update({
  id: '/streams/',
  path: '/streams/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRfidTagsIndexRoute = DashboardRfidTagsIndexRouteImport.update({
  id: '/rfid-tags/',
  path: '/rfid-tags/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRequestsIndexRoute = DashboardRequestsIndexRouteImport.update({
  id: '/requests/',
  path: '/requests/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReportsIndexRoute = DashboardReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLaboratoriesIndexRoute =
  DashboardLaboratoriesIndexRouteImport.update({
    id: '/laboratories/',
    path: '/laboratories/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstitutionsIndexRoute =
  DashboardInstitutionsIndexRouteImport.update({
    id: '/institutions/',
    path: '/institutions/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstitutesIndexRoute =
  DashboardInstitutesIndexRouteImport.update({
    id: '/institutes/',
    path: '/institutes/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstallerIndexRoute = DashboardInstallerIndexRouteImport.update({
  id: '/installer/',
  path: '/installer/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardInstallationsIndexRoute =
  DashboardInstallationsIndexRouteImport.update({
    id: '/installations/',
    path: '/installations/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardGroupsIndexRoute = DashboardGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDevicesIndexRoute = DashboardDevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCertificationsIndexRoute =
  DashboardCertificationsIndexRouteImport.update({
    id: '/certifications/',
    path: '/certifications/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardStreamsSessionIdRoute =
  DashboardStreamsSessionIdRouteImport.update({
    id: '/streams/$sessionId',
    path: '/streams/$sessionId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardRfidTagsNewRoute = DashboardRfidTagsNewRouteImport.update({
  id: '/rfid-tags/new',
  path: '/rfid-tags/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRequestsIdRoute = DashboardRequestsIdRouteImport.update({
  id: '/requests/$id',
  path: '/requests/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReportsNewRoute = DashboardReportsNewRouteImport.update({
  id: '/reports/new',
  path: '/reports/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReportsIdRoute = DashboardReportsIdRouteImport.update({
  id: '/reports/$id',
  path: '/reports/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLaboratoriesNewRoute =
  DashboardLaboratoriesNewRouteImport.update({
    id: '/laboratories/new',
    path: '/laboratories/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardLaboratoriesIdRoute = DashboardLaboratoriesIdRouteImport.update({
  id: '/laboratories/$id',
  path: '/laboratories/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardInstitutionsNewRoute =
  DashboardInstitutionsNewRouteImport.update({
    id: '/institutions/new',
    path: '/institutions/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstitutionsIdRoute = DashboardInstitutionsIdRouteImport.update({
  id: '/institutions/$id',
  path: '/institutions/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardInstitutesSplatRoute =
  DashboardInstitutesSplatRouteImport.update({
    id: '/institutes/$',
    path: '/institutes/$',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstallationsNewRoute =
  DashboardInstallationsNewRouteImport.update({
    id: '/installations/new',
    path: '/installations/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstallationsIdRoute =
  DashboardInstallationsIdRouteImport.update({
    id: '/installations/$id',
    path: '/installations/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardGroupsNewRoute = DashboardGroupsNewRouteImport.update({
  id: '/groups/new',
  path: '/groups/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardGroupsIdRoute = DashboardGroupsIdRouteImport.update({
  id: '/groups/$id',
  path: '/groups/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDevicesNewRoute = DashboardDevicesNewRouteImport.update({
  id: '/devices/new',
  path: '/devices/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDevicesIdRoute = DashboardDevicesIdRouteImport.update({
  id: '/devices/$id',
  path: '/devices/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCertificationsIdRoute =
  DashboardCertificationsIdRouteImport.update({
    id: '/certifications/$id',
    path: '/certifications/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardReportsSchedulesIndexRoute =
  DashboardReportsSchedulesIndexRouteImport.update({
    id: '/reports/schedules/',
    path: '/reports/schedules/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardLaboratoriesIdIndexRoute =
  DashboardLaboratoriesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardLaboratoriesIdRoute,
  } as any)
const DashboardInstitutionsIdIndexRoute =
  DashboardInstitutionsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInstitutionsIdRoute,
  } as any)
const DashboardInstallerJobsIndexRoute =
  DashboardInstallerJobsIndexRouteImport.update({
    id: '/installer/jobs/',
    path: '/installer/jobs/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstallationsIdIndexRoute =
  DashboardInstallationsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInstallationsIdRoute,
  } as any)
const DashboardGroupsIdIndexRoute = DashboardGroupsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardGroupsIdRoute,
} as any)
const DashboardDevicesIdIndexRoute = DashboardDevicesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardDevicesIdRoute,
} as any)
const DashboardCertificationsIdIndexRoute =
  DashboardCertificationsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCertificationsIdRoute,
  } as any)
const DashboardUsersNewTenantIdRoute =
  DashboardUsersNewTenantIdRouteImport.update({
    id: '/users/new/$tenantId',
    path: '/users/new/$tenantId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardUsersImportTenantIdRoute =
  DashboardUsersImportTenantIdRouteImport.update({
    id: '/users/import/$tenantId',
    path: '/users/import/$tenantId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardUsersIdTenantIdRoute =
  DashboardUsersIdTenantIdRouteImport.update({
    id: '/users/$id/$tenantId',
    path: '/users/$id/$tenantId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardLaboratoriesIdEditRoute =
  DashboardLaboratoriesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardLaboratoriesIdRoute,
  } as any)
const DashboardInstitutionsIdStorageRoute =
  DashboardInstitutionsIdStorageRouteImport.update({
    id: '/storage',
    path: '/storage',
    getParentRoute: () => DashboardInstitutionsIdRoute,
  } as any)
const DashboardInstitutionsIdEditRoute =
  DashboardInstitutionsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardInstitutionsIdRoute,
  } as any)
const DashboardInstallerJobsIdRoute =
  DashboardInstallerJobsIdRouteImport.update({
    id: '/installer/jobs/$id',
    path: '/installer/jobs/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstallerInstallationsIdRoute =
  DashboardInstallerInstallationsIdRouteImport.update({
    id: '/installer/installations/$id',
    path: '/installer/installations/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstallationsIdEditRoute =
  DashboardInstallationsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardInstallationsIdRoute,
  } as any)
const DashboardGroupsIdEditRoute = DashboardGroupsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => DashboardGroupsIdRoute,
} as any)
const DashboardDevicesIdEditRoute = DashboardDevicesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => DashboardDevicesIdRoute,
} as any)
const DashboardCertificationsIdEditRoute =
  DashboardCertificationsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardCertificationsIdRoute,
  } as any)
const DashboardUsersIdTenantIdIndexRoute =
  DashboardUsersIdTenantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)
const DashboardInstallerInstallationsIdIndexRoute =
  DashboardInstallerInstallationsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInstallerInstallationsIdRoute,
  } as any)
const DashboardUsersIdTenantIdPermissionsRoute =
  DashboardUsersIdTenantIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)
const DashboardUsersIdTenantIdMoveRoute =
  DashboardUsersIdTenantIdMoveRouteImport.update({
    id: '/move',
    path: '/move',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)
const DashboardUsersIdTenantIdEditRoute =
  DashboardUsersIdTenantIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)
const DashboardUsersIdTenantIdCertificationsRoute =
  DashboardUsersIdTenantIdCertificationsRouteImport.update({
    id: '/certifications',
    path: '/certifications',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)
const DashboardReportsSchedulesIdEditRoute =
  DashboardReportsSchedulesIdEditRouteImport.update({
    id: '/reports/schedules/$id/edit',
    path: '/reports/schedules/$id/edit',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardInstallerInstallationsIdSensorVerificationRoute =
  DashboardInstallerInstallationsIdSensorVerificationRouteImport.update({
    id: '/sensor-verification',
    path: '/sensor-verification',
    getParentRoute: () => DashboardInstallerInstallationsIdRoute,
  } as any)
const DashboardInstallerInstallationsIdRegistrationRoute =
  DashboardInstallerInstallationsIdRegistrationRouteImport.update({
    id: '/registration',
    path: '/registration',
    getParentRoute: () => DashboardInstallerInstallationsIdRoute,
  } as any)
const DashboardInstallerInstallationsIdChecklistRoute =
  DashboardInstallerInstallationsIdChecklistRouteImport.update({
    id: '/checklist',
    path: '/checklist',
    getParentRoute: () => DashboardInstallerInstallationsIdRoute,
  } as any)
const DashboardInstallerInstallationsIdCalibrationRoute =
  DashboardInstallerInstallationsIdCalibrationRouteImport.update({
    id: '/calibration',
    path: '/calibration',
    getParentRoute: () => DashboardInstallerInstallationsIdRoute,
  } as any)
const DashboardInstallerInstallationsIdAirflowMonitorTestRoute =
  DashboardInstallerInstallationsIdAirflowMonitorTestRouteImport.update({
    id: '/airflow-monitor-test',
    path: '/airflow-monitor-test',
    getParentRoute: () => DashboardInstallerInstallationsIdRoute,
  } as any)
const DashboardUsersIdTenantIdAccessIndexRoute =
  DashboardUsersIdTenantIdAccessIndexRouteImport.update({
    id: '/access/',
    path: '/access/',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)
const DashboardUsersIdTenantIdAccessNewRoute =
  DashboardUsersIdTenantIdAccessNewRouteImport.update({
    id: '/access/new',
    path: '/access/new',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)
const DashboardUsersIdTenantIdAccessGrantIdEditRoute =
  DashboardUsersIdTenantIdAccessGrantIdEditRouteImport.update({
    id: '/access/$grantId/edit',
    path: '/access/$grantId/edit',
    getParentRoute: () => DashboardUsersIdTenantIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/device-registration': typeof DeviceRegistrationRoute
  '/login': typeof LoginRoute
  '/rfid-assignment': typeof RfidAssignmentRoute
  '/$': typeof DashboardSplatRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/forbidden': typeof DashboardForbiddenRoute
  '/logs': typeof DashboardLogsRoute
  '/notifications': typeof DashboardNotificationsRoute
  '/settings': typeof DashboardSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/certifications/$id': typeof DashboardCertificationsIdRouteWithChildren
  '/devices/$id': typeof DashboardDevicesIdRouteWithChildren
  '/devices/new': typeof DashboardDevicesNewRoute
  '/groups/$id': typeof DashboardGroupsIdRouteWithChildren
  '/groups/new': typeof DashboardGroupsNewRoute
  '/installations/$id': typeof DashboardInstallationsIdRouteWithChildren
  '/installations/new': typeof DashboardInstallationsNewRoute
  '/institutes/$': typeof DashboardInstitutesSplatRoute
  '/institutions/$id': typeof DashboardInstitutionsIdRouteWithChildren
  '/institutions/new': typeof DashboardInstitutionsNewRoute
  '/laboratories/$id': typeof DashboardLaboratoriesIdRouteWithChildren
  '/laboratories/new': typeof DashboardLaboratoriesNewRoute
  '/reports/$id': typeof DashboardReportsIdRoute
  '/reports/new': typeof DashboardReportsNewRoute
  '/requests/$id': typeof DashboardRequestsIdRoute
  '/rfid-tags/new': typeof DashboardRfidTagsNewRoute
  '/streams/$sessionId': typeof DashboardStreamsSessionIdRoute
  '/certifications/': typeof DashboardCertificationsIndexRoute
  '/devices/': typeof DashboardDevicesIndexRoute
  '/groups/': typeof DashboardGroupsIndexRoute
  '/installations/': typeof DashboardInstallationsIndexRoute
  '/installer/': typeof DashboardInstallerIndexRoute
  '/institutes/': typeof DashboardInstitutesIndexRoute
  '/institutions/': typeof DashboardInstitutionsIndexRoute
  '/laboratories/': typeof DashboardLaboratoriesIndexRoute
  '/reports/': typeof DashboardReportsIndexRoute
  '/requests/': typeof DashboardRequestsIndexRoute
  '/rfid-tags/': typeof DashboardRfidTagsIndexRoute
  '/streams/': typeof DashboardStreamsIndexRoute
  '/users/': typeof DashboardUsersIndexRoute
  '/certifications/$id/edit': typeof DashboardCertificationsIdEditRoute
  '/devices/$id/edit': typeof DashboardDevicesIdEditRoute
  '/groups/$id/edit': typeof DashboardGroupsIdEditRoute
  '/installations/$id/edit': typeof DashboardInstallationsIdEditRoute
  '/installer/installations/$id': typeof DashboardInstallerInstallationsIdRouteWithChildren
  '/installer/jobs/$id': typeof DashboardInstallerJobsIdRoute
  '/institutions/$id/edit': typeof DashboardInstitutionsIdEditRoute
  '/institutions/$id/storage': typeof DashboardInstitutionsIdStorageRoute
  '/laboratories/$id/edit': typeof DashboardLaboratoriesIdEditRoute
  '/users/$id/$tenantId': typeof DashboardUsersIdTenantIdRouteWithChildren
  '/users/import/$tenantId': typeof DashboardUsersImportTenantIdRoute
  '/users/new/$tenantId': typeof DashboardUsersNewTenantIdRoute
  '/certifications/$id/': typeof DashboardCertificationsIdIndexRoute
  '/devices/$id/': typeof DashboardDevicesIdIndexRoute
  '/groups/$id/': typeof DashboardGroupsIdIndexRoute
  '/installations/$id/': typeof DashboardInstallationsIdIndexRoute
  '/installer/jobs/': typeof DashboardInstallerJobsIndexRoute
  '/institutions/$id/': typeof DashboardInstitutionsIdIndexRoute
  '/laboratories/$id/': typeof DashboardLaboratoriesIdIndexRoute
  '/reports/schedules/': typeof DashboardReportsSchedulesIndexRoute
  '/installer/installations/$id/airflow-monitor-test': typeof DashboardInstallerInstallationsIdAirflowMonitorTestRoute
  '/installer/installations/$id/calibration': typeof DashboardInstallerInstallationsIdCalibrationRoute
  '/installer/installations/$id/checklist': typeof DashboardInstallerInstallationsIdChecklistRoute
  '/installer/installations/$id/registration': typeof DashboardInstallerInstallationsIdRegistrationRoute
  '/installer/installations/$id/sensor-verification': typeof DashboardInstallerInstallationsIdSensorVerificationRoute
  '/reports/schedules/$id/edit': typeof DashboardReportsSchedulesIdEditRoute
  '/users/$id/$tenantId/certifications': typeof DashboardUsersIdTenantIdCertificationsRoute
  '/users/$id/$tenantId/edit': typeof DashboardUsersIdTenantIdEditRoute
  '/users/$id/$tenantId/move': typeof DashboardUsersIdTenantIdMoveRoute
  '/users/$id/$tenantId/permissions': typeof DashboardUsersIdTenantIdPermissionsRoute
  '/installer/installations/$id/': typeof DashboardInstallerInstallationsIdIndexRoute
  '/users/$id/$tenantId/': typeof DashboardUsersIdTenantIdIndexRoute
  '/users/$id/$tenantId/access/new': typeof DashboardUsersIdTenantIdAccessNewRoute
  '/users/$id/$tenantId/access/': typeof DashboardUsersIdTenantIdAccessIndexRoute
  '/users/$id/$tenantId/access/$grantId/edit': typeof DashboardUsersIdTenantIdAccessGrantIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/device-registration': typeof DeviceRegistrationRoute
  '/login': typeof LoginRoute
  '/rfid-assignment': typeof RfidAssignmentRoute
  '/$': typeof DashboardSplatRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/forbidden': typeof DashboardForbiddenRoute
  '/logs': typeof DashboardLogsRoute
  '/notifications': typeof DashboardNotificationsRoute
  '/settings': typeof DashboardSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/devices/new': typeof DashboardDevicesNewRoute
  '/groups/new': typeof DashboardGroupsNewRoute
  '/installations/new': typeof DashboardInstallationsNewRoute
  '/institutes/$': typeof DashboardInstitutesSplatRoute
  '/institutions/new': typeof DashboardInstitutionsNewRoute
  '/laboratories/new': typeof DashboardLaboratoriesNewRoute
  '/reports/$id': typeof DashboardReportsIdRoute
  '/reports/new': typeof DashboardReportsNewRoute
  '/requests/$id': typeof DashboardRequestsIdRoute
  '/rfid-tags/new': typeof DashboardRfidTagsNewRoute
  '/streams/$sessionId': typeof DashboardStreamsSessionIdRoute
  '/certifications': typeof DashboardCertificationsIndexRoute
  '/devices': typeof DashboardDevicesIndexRoute
  '/groups': typeof DashboardGroupsIndexRoute
  '/installations': typeof DashboardInstallationsIndexRoute
  '/installer': typeof DashboardInstallerIndexRoute
  '/institutes': typeof DashboardInstitutesIndexRoute
  '/institutions': typeof DashboardInstitutionsIndexRoute
  '/laboratories': typeof DashboardLaboratoriesIndexRoute
  '/reports': typeof DashboardReportsIndexRoute
  '/requests': typeof DashboardRequestsIndexRoute
  '/rfid-tags': typeof DashboardRfidTagsIndexRoute
  '/streams': typeof DashboardStreamsIndexRoute
  '/users': typeof DashboardUsersIndexRoute
  '/certifications/$id/edit': typeof DashboardCertificationsIdEditRoute
  '/devices/$id/edit': typeof DashboardDevicesIdEditRoute
  '/groups/$id/edit': typeof DashboardGroupsIdEditRoute
  '/installations/$id/edit': typeof DashboardInstallationsIdEditRoute
  '/installer/jobs/$id': typeof DashboardInstallerJobsIdRoute
  '/institutions/$id/edit': typeof DashboardInstitutionsIdEditRoute
  '/institutions/$id/storage': typeof DashboardInstitutionsIdStorageRoute
  '/laboratories/$id/edit': typeof DashboardLaboratoriesIdEditRoute
  '/users/import/$tenantId': typeof DashboardUsersImportTenantIdRoute
  '/users/new/$tenantId': typeof DashboardUsersNewTenantIdRoute
  '/certifications/$id': typeof DashboardCertificationsIdIndexRoute
  '/devices/$id': typeof DashboardDevicesIdIndexRoute
  '/groups/$id': typeof DashboardGroupsIdIndexRoute
  '/installations/$id': typeof DashboardInstallationsIdIndexRoute
  '/installer/jobs': typeof DashboardInstallerJobsIndexRoute
  '/institutions/$id': typeof DashboardInstitutionsIdIndexRoute
  '/laboratories/$id': typeof DashboardLaboratoriesIdIndexRoute
  '/reports/schedules': typeof DashboardReportsSchedulesIndexRoute
  '/installer/installations/$id/airflow-monitor-test': typeof DashboardInstallerInstallationsIdAirflowMonitorTestRoute
  '/installer/installations/$id/calibration': typeof DashboardInstallerInstallationsIdCalibrationRoute
  '/installer/installations/$id/checklist': typeof DashboardInstallerInstallationsIdChecklistRoute
  '/installer/installations/$id/registration': typeof DashboardInstallerInstallationsIdRegistrationRoute
  '/installer/installations/$id/sensor-verification': typeof DashboardInstallerInstallationsIdSensorVerificationRoute
  '/reports/schedules/$id/edit': typeof DashboardReportsSchedulesIdEditRoute
  '/users/$id/$tenantId/certifications': typeof DashboardUsersIdTenantIdCertificationsRoute
  '/users/$id/$tenantId/edit': typeof DashboardUsersIdTenantIdEditRoute
  '/users/$id/$tenantId/move': typeof DashboardUsersIdTenantIdMoveRoute
  '/users/$id/$tenantId/permissions': typeof DashboardUsersIdTenantIdPermissionsRoute
  '/installer/installations/$id': typeof DashboardInstallerInstallationsIdIndexRoute
  '/users/$id/$tenantId': typeof DashboardUsersIdTenantIdIndexRoute
  '/users/$id/$tenantId/access/new': typeof DashboardUsersIdTenantIdAccessNewRoute
  '/users/$id/$tenantId/access': typeof DashboardUsersIdTenantIdAccessIndexRoute
  '/users/$id/$tenantId/access/$grantId/edit': typeof DashboardUsersIdTenantIdAccessGrantIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/device-registration': typeof DeviceRegistrationRoute
  '/login': typeof LoginRoute
  '/rfid-assignment': typeof RfidAssignmentRoute
  '/_dashboard/$': typeof DashboardSplatRoute
  '/_dashboard/dashboard': typeof DashboardDashboardRoute
  '/_dashboard/forbidden': typeof DashboardForbiddenRoute
  '/_dashboard/logs': typeof DashboardLogsRoute
  '/_dashboard/notifications': typeof DashboardNotificationsRoute
  '/_dashboard/settings': typeof DashboardSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_dashboard/certifications/$id': typeof DashboardCertificationsIdRouteWithChildren
  '/_dashboard/devices/$id': typeof DashboardDevicesIdRouteWithChildren
  '/_dashboard/devices/new': typeof DashboardDevicesNewRoute
  '/_dashboard/groups/$id': typeof DashboardGroupsIdRouteWithChildren
  '/_dashboard/groups/new': typeof DashboardGroupsNewRoute
  '/_dashboard/installations/$id': typeof DashboardInstallationsIdRouteWithChildren
  '/_dashboard/installations/new': typeof DashboardInstallationsNewRoute
  '/_dashboard/institutes/$': typeof DashboardInstitutesSplatRoute
  '/_dashboard/institutions/$id': typeof DashboardInstitutionsIdRouteWithChildren
  '/_dashboard/institutions/new': typeof DashboardInstitutionsNewRoute
  '/_dashboard/laboratories/$id': typeof DashboardLaboratoriesIdRouteWithChildren
  '/_dashboard/laboratories/new': typeof DashboardLaboratoriesNewRoute
  '/_dashboard/reports/$id': typeof DashboardReportsIdRoute
  '/_dashboard/reports/new': typeof DashboardReportsNewRoute
  '/_dashboard/requests/$id': typeof DashboardRequestsIdRoute
  '/_dashboard/rfid-tags/new': typeof DashboardRfidTagsNewRoute
  '/_dashboard/streams/$sessionId': typeof DashboardStreamsSessionIdRoute
  '/_dashboard/certifications/': typeof DashboardCertificationsIndexRoute
  '/_dashboard/devices/': typeof DashboardDevicesIndexRoute
  '/_dashboard/groups/': typeof DashboardGroupsIndexRoute
  '/_dashboard/installations/': typeof DashboardInstallationsIndexRoute
  '/_dashboard/installer/': typeof DashboardInstallerIndexRoute
  '/_dashboard/institutes/': typeof DashboardInstitutesIndexRoute
  '/_dashboard/institutions/': typeof DashboardInstitutionsIndexRoute
  '/_dashboard/laboratories/': typeof DashboardLaboratoriesIndexRoute
  '/_dashboard/reports/': typeof DashboardReportsIndexRoute
  '/_dashboard/requests/': typeof DashboardRequestsIndexRoute
  '/_dashboard/rfid-tags/': typeof DashboardRfidTagsIndexRoute
  '/_dashboard/streams/': typeof DashboardStreamsIndexRoute
  '/_dashboard/users/': typeof DashboardUsersIndexRoute
  '/_dashboard/certifications/$id/edit': typeof DashboardCertificationsIdEditRoute
  '/_dashboard/devices/$id/edit': typeof DashboardDevicesIdEditRoute
  '/_dashboard/groups/$id/edit': typeof DashboardGroupsIdEditRoute
  '/_dashboard/installations/$id/edit': typeof DashboardInstallationsIdEditRoute
  '/_dashboard/installer/installations/$id': typeof DashboardInstallerInstallationsIdRouteWithChildren
  '/_dashboard/installer/jobs/$id': typeof DashboardInstallerJobsIdRoute
  '/_dashboard/institutions/$id/edit': typeof DashboardInstitutionsIdEditRoute
  '/_dashboard/institutions/$id/storage': typeof DashboardInstitutionsIdStorageRoute
  '/_dashboard/laboratories/$id/edit': typeof DashboardLaboratoriesIdEditRoute
  '/_dashboard/users/$id/$tenantId': typeof DashboardUsersIdTenantIdRouteWithChildren
  '/_dashboard/users/import/$tenantId': typeof DashboardUsersImportTenantIdRoute
  '/_dashboard/users/new/$tenantId': typeof DashboardUsersNewTenantIdRoute
  '/_dashboard/certifications/$id/': typeof DashboardCertificationsIdIndexRoute
  '/_dashboard/devices/$id/': typeof DashboardDevicesIdIndexRoute
  '/_dashboard/groups/$id/': typeof DashboardGroupsIdIndexRoute
  '/_dashboard/installations/$id/': typeof DashboardInstallationsIdIndexRoute
  '/_dashboard/installer/jobs/': typeof DashboardInstallerJobsIndexRoute
  '/_dashboard/institutions/$id/': typeof DashboardInstitutionsIdIndexRoute
  '/_dashboard/laboratories/$id/': typeof DashboardLaboratoriesIdIndexRoute
  '/_dashboard/reports/schedules/': typeof DashboardReportsSchedulesIndexRoute
  '/_dashboard/installer/installations/$id/airflow-monitor-test': typeof DashboardInstallerInstallationsIdAirflowMonitorTestRoute
  '/_dashboard/installer/installations/$id/calibration': typeof DashboardInstallerInstallationsIdCalibrationRoute
  '/_dashboard/installer/installations/$id/checklist': typeof DashboardInstallerInstallationsIdChecklistRoute
  '/_dashboard/installer/installations/$id/registration': typeof DashboardInstallerInstallationsIdRegistrationRoute
  '/_dashboard/installer/installations/$id/sensor-verification': typeof DashboardInstallerInstallationsIdSensorVerificationRoute
  '/_dashboard/reports/schedules/$id/edit': typeof DashboardReportsSchedulesIdEditRoute
  '/_dashboard/users/$id/$tenantId/certifications': typeof DashboardUsersIdTenantIdCertificationsRoute
  '/_dashboard/users/$id/$tenantId/edit': typeof DashboardUsersIdTenantIdEditRoute
  '/_dashboard/users/$id/$tenantId/move': typeof DashboardUsersIdTenantIdMoveRoute
  '/_dashboard/users/$id/$tenantId/permissions': typeof DashboardUsersIdTenantIdPermissionsRoute
  '/_dashboard/installer/installations/$id/': typeof DashboardInstallerInstallationsIdIndexRoute
  '/_dashboard/users/$id/$tenantId/': typeof DashboardUsersIdTenantIdIndexRoute
  '/_dashboard/users/$id/$tenantId/access/new': typeof DashboardUsersIdTenantIdAccessNewRoute
  '/_dashboard/users/$id/$tenantId/access/': typeof DashboardUsersIdTenantIdAccessIndexRoute
  '/_dashboard/users/$id/$tenantId/access/$grantId/edit': typeof DashboardUsersIdTenantIdAccessGrantIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/device-registration'
    | '/login'
    | '/rfid-assignment'
    | '/$'
    | '/dashboard'
    | '/forbidden'
    | '/logs'
    | '/notifications'
    | '/settings'
    | '/auth/callback'
    | '/certifications/$id'
    | '/devices/$id'
    | '/devices/new'
    | '/groups/$id'
    | '/groups/new'
    | '/installations/$id'
    | '/installations/new'
    | '/institutes/$'
    | '/institutions/$id'
    | '/institutions/new'
    | '/laboratories/$id'
    | '/laboratories/new'
    | '/reports/$id'
    | '/reports/new'
    | '/requests/$id'
    | '/rfid-tags/new'
    | '/streams/$sessionId'
    | '/certifications/'
    | '/devices/'
    | '/groups/'
    | '/installations/'
    | '/installer/'
    | '/institutes/'
    | '/institutions/'
    | '/laboratories/'
    | '/reports/'
    | '/requests/'
    | '/rfid-tags/'
    | '/streams/'
    | '/users/'
    | '/certifications/$id/edit'
    | '/devices/$id/edit'
    | '/groups/$id/edit'
    | '/installations/$id/edit'
    | '/installer/installations/$id'
    | '/installer/jobs/$id'
    | '/institutions/$id/edit'
    | '/institutions/$id/storage'
    | '/laboratories/$id/edit'
    | '/users/$id/$tenantId'
    | '/users/import/$tenantId'
    | '/users/new/$tenantId'
    | '/certifications/$id/'
    | '/devices/$id/'
    | '/groups/$id/'
    | '/installations/$id/'
    | '/installer/jobs/'
    | '/institutions/$id/'
    | '/laboratories/$id/'
    | '/reports/schedules/'
    | '/installer/installations/$id/airflow-monitor-test'
    | '/installer/installations/$id/calibration'
    | '/installer/installations/$id/checklist'
    | '/installer/installations/$id/registration'
    | '/installer/installations/$id/sensor-verification'
    | '/reports/schedules/$id/edit'
    | '/users/$id/$tenantId/certifications'
    | '/users/$id/$tenantId/edit'
    | '/users/$id/$tenantId/move'
    | '/users/$id/$tenantId/permissions'
    | '/installer/installations/$id/'
    | '/users/$id/$tenantId/'
    | '/users/$id/$tenantId/access/new'
    | '/users/$id/$tenantId/access/'
    | '/users/$id/$tenantId/access/$grantId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/change-password'
    | '/device-registration'
    | '/login'
    | '/rfid-assignment'
    | '/$'
    | '/dashboard'
    | '/forbidden'
    | '/logs'
    | '/notifications'
    | '/settings'
    | '/auth/callback'
    | '/devices/new'
    | '/groups/new'
    | '/installations/new'
    | '/institutes/$'
    | '/institutions/new'
    | '/laboratories/new'
    | '/reports/$id'
    | '/reports/new'
    | '/requests/$id'
    | '/rfid-tags/new'
    | '/streams/$sessionId'
    | '/certifications'
    | '/devices'
    | '/groups'
    | '/installations'
    | '/installer'
    | '/institutes'
    | '/institutions'
    | '/laboratories'
    | '/reports'
    | '/requests'
    | '/rfid-tags'
    | '/streams'
    | '/users'
    | '/certifications/$id/edit'
    | '/devices/$id/edit'
    | '/groups/$id/edit'
    | '/installations/$id/edit'
    | '/installer/jobs/$id'
    | '/institutions/$id/edit'
    | '/institutions/$id/storage'
    | '/laboratories/$id/edit'
    | '/users/import/$tenantId'
    | '/users/new/$tenantId'
    | '/certifications/$id'
    | '/devices/$id'
    | '/groups/$id'
    | '/installations/$id'
    | '/installer/jobs'
    | '/institutions/$id'
    | '/laboratories/$id'
    | '/reports/schedules'
    | '/installer/installations/$id/airflow-monitor-test'
    | '/installer/installations/$id/calibration'
    | '/installer/installations/$id/checklist'
    | '/installer/installations/$id/registration'
    | '/installer/installations/$id/sensor-verification'
    | '/reports/schedules/$id/edit'
    | '/users/$id/$tenantId/certifications'
    | '/users/$id/$tenantId/edit'
    | '/users/$id/$tenantId/move'
    | '/users/$id/$tenantId/permissions'
    | '/installer/installations/$id'
    | '/users/$id/$tenantId'
    | '/users/$id/$tenantId/access/new'
    | '/users/$id/$tenantId/access'
    | '/users/$id/$tenantId/access/$grantId/edit'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/change-password'
    | '/device-registration'
    | '/login'
    | '/rfid-assignment'
    | '/_dashboard/$'
    | '/_dashboard/dashboard'
    | '/_dashboard/forbidden'
    | '/_dashboard/logs'
    | '/_dashboard/notifications'
    | '/_dashboard/settings'
    | '/auth/callback'
    | '/_dashboard/certifications/$id'
    | '/_dashboard/devices/$id'
    | '/_dashboard/devices/new'
    | '/_dashboard/groups/$id'
    | '/_dashboard/groups/new'
    | '/_dashboard/installations/$id'
    | '/_dashboard/installations/new'
    | '/_dashboard/institutes/$'
    | '/_dashboard/institutions/$id'
    | '/_dashboard/institutions/new'
    | '/_dashboard/laboratories/$id'
    | '/_dashboard/laboratories/new'
    | '/_dashboard/reports/$id'
    | '/_dashboard/reports/new'
    | '/_dashboard/requests/$id'
    | '/_dashboard/rfid-tags/new'
    | '/_dashboard/streams/$sessionId'
    | '/_dashboard/certifications/'
    | '/_dashboard/devices/'
    | '/_dashboard/groups/'
    | '/_dashboard/installations/'
    | '/_dashboard/installer/'
    | '/_dashboard/institutes/'
    | '/_dashboard/institutions/'
    | '/_dashboard/laboratories/'
    | '/_dashboard/reports/'
    | '/_dashboard/requests/'
    | '/_dashboard/rfid-tags/'
    | '/_dashboard/streams/'
    | '/_dashboard/users/'
    | '/_dashboard/certifications/$id/edit'
    | '/_dashboard/devices/$id/edit'
    | '/_dashboard/groups/$id/edit'
    | '/_dashboard/installations/$id/edit'
    | '/_dashboard/installer/installations/$id'
    | '/_dashboard/installer/jobs/$id'
    | '/_dashboard/institutions/$id/edit'
    | '/_dashboard/institutions/$id/storage'
    | '/_dashboard/laboratories/$id/edit'
    | '/_dashboard/users/$id/$tenantId'
    | '/_dashboard/users/import/$tenantId'
    | '/_dashboard/users/new/$tenantId'
    | '/_dashboard/certifications/$id/'
    | '/_dashboard/devices/$id/'
    | '/_dashboard/groups/$id/'
    | '/_dashboard/installations/$id/'
    | '/_dashboard/installer/jobs/'
    | '/_dashboard/institutions/$id/'
    | '/_dashboard/laboratories/$id/'
    | '/_dashboard/reports/schedules/'
    | '/_dashboard/installer/installations/$id/airflow-monitor-test'
    | '/_dashboard/installer/installations/$id/calibration'
    | '/_dashboard/installer/installations/$id/checklist'
    | '/_dashboard/installer/installations/$id/registration'
    | '/_dashboard/installer/installations/$id/sensor-verification'
    | '/_dashboard/reports/schedules/$id/edit'
    | '/_dashboard/users/$id/$tenantId/certifications'
    | '/_dashboard/users/$id/$tenantId/edit'
    | '/_dashboard/users/$id/$tenantId/move'
    | '/_dashboard/users/$id/$tenantId/permissions'
    | '/_dashboard/installer/installations/$id/'
    | '/_dashboard/users/$id/$tenantId/'
    | '/_dashboard/users/$id/$tenantId/access/new'
    | '/_dashboard/users/$id/$tenantId/access/'
    | '/_dashboard/users/$id/$tenantId/access/$grantId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  DeviceRegistrationRoute: typeof DeviceRegistrationRoute
  LoginRoute: typeof LoginRoute
  RfidAssignmentRoute: typeof RfidAssignmentRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/rfid-assignment': {
      id: '/rfid-assignment'
      path: '/rfid-assignment'
      fullPath: '/rfid-assignment'
      preLoaderRoute: typeof RfidAssignmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device-registration': {
      id: '/device-registration'
      path: '/device-registration'
      fullPath: '/device-registration'
      preLoaderRoute: typeof DeviceRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/notifications': {
      id: '/_dashboard/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof DashboardNotificationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/logs': {
      id: '/_dashboard/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof DashboardLogsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/forbidden': {
      id: '/_dashboard/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof DashboardForbiddenRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard': {
      id: '/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/$': {
      id: '/_dashboard/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof DashboardSplatRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/users/': {
      id: '/_dashboard/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/streams/': {
      id: '/_dashboard/streams/'
      path: '/streams'
      fullPath: '/streams/'
      preLoaderRoute: typeof DashboardStreamsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/rfid-tags/': {
      id: '/_dashboard/rfid-tags/'
      path: '/rfid-tags'
      fullPath: '/rfid-tags/'
      preLoaderRoute: typeof DashboardRfidTagsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/requests/': {
      id: '/_dashboard/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof DashboardRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reports/': {
      id: '/_dashboard/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof DashboardReportsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/laboratories/': {
      id: '/_dashboard/laboratories/'
      path: '/laboratories'
      fullPath: '/laboratories/'
      preLoaderRoute: typeof DashboardLaboratoriesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/institutions/': {
      id: '/_dashboard/institutions/'
      path: '/institutions'
      fullPath: '/institutions/'
      preLoaderRoute: typeof DashboardInstitutionsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/institutes/': {
      id: '/_dashboard/institutes/'
      path: '/institutes'
      fullPath: '/institutes/'
      preLoaderRoute: typeof DashboardInstitutesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installer/': {
      id: '/_dashboard/installer/'
      path: '/installer'
      fullPath: '/installer/'
      preLoaderRoute: typeof DashboardInstallerIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installations/': {
      id: '/_dashboard/installations/'
      path: '/installations'
      fullPath: '/installations/'
      preLoaderRoute: typeof DashboardInstallationsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/groups/': {
      id: '/_dashboard/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof DashboardGroupsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/devices/': {
      id: '/_dashboard/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof DashboardDevicesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/certifications/': {
      id: '/_dashboard/certifications/'
      path: '/certifications'
      fullPath: '/certifications/'
      preLoaderRoute: typeof DashboardCertificationsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/streams/$sessionId': {
      id: '/_dashboard/streams/$sessionId'
      path: '/streams/$sessionId'
      fullPath: '/streams/$sessionId'
      preLoaderRoute: typeof DashboardStreamsSessionIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/rfid-tags/new': {
      id: '/_dashboard/rfid-tags/new'
      path: '/rfid-tags/new'
      fullPath: '/rfid-tags/new'
      preLoaderRoute: typeof DashboardRfidTagsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/requests/$id': {
      id: '/_dashboard/requests/$id'
      path: '/requests/$id'
      fullPath: '/requests/$id'
      preLoaderRoute: typeof DashboardRequestsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reports/new': {
      id: '/_dashboard/reports/new'
      path: '/reports/new'
      fullPath: '/reports/new'
      preLoaderRoute: typeof DashboardReportsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reports/$id': {
      id: '/_dashboard/reports/$id'
      path: '/reports/$id'
      fullPath: '/reports/$id'
      preLoaderRoute: typeof DashboardReportsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/laboratories/new': {
      id: '/_dashboard/laboratories/new'
      path: '/laboratories/new'
      fullPath: '/laboratories/new'
      preLoaderRoute: typeof DashboardLaboratoriesNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/laboratories/$id': {
      id: '/_dashboard/laboratories/$id'
      path: '/laboratories/$id'
      fullPath: '/laboratories/$id'
      preLoaderRoute: typeof DashboardLaboratoriesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/institutions/new': {
      id: '/_dashboard/institutions/new'
      path: '/institutions/new'
      fullPath: '/institutions/new'
      preLoaderRoute: typeof DashboardInstitutionsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/institutions/$id': {
      id: '/_dashboard/institutions/$id'
      path: '/institutions/$id'
      fullPath: '/institutions/$id'
      preLoaderRoute: typeof DashboardInstitutionsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/institutes/$': {
      id: '/_dashboard/institutes/$'
      path: '/institutes/$'
      fullPath: '/institutes/$'
      preLoaderRoute: typeof DashboardInstitutesSplatRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installations/new': {
      id: '/_dashboard/installations/new'
      path: '/installations/new'
      fullPath: '/installations/new'
      preLoaderRoute: typeof DashboardInstallationsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installations/$id': {
      id: '/_dashboard/installations/$id'
      path: '/installations/$id'
      fullPath: '/installations/$id'
      preLoaderRoute: typeof DashboardInstallationsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/groups/new': {
      id: '/_dashboard/groups/new'
      path: '/groups/new'
      fullPath: '/groups/new'
      preLoaderRoute: typeof DashboardGroupsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/groups/$id': {
      id: '/_dashboard/groups/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof DashboardGroupsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/devices/new': {
      id: '/_dashboard/devices/new'
      path: '/devices/new'
      fullPath: '/devices/new'
      preLoaderRoute: typeof DashboardDevicesNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/devices/$id': {
      id: '/_dashboard/devices/$id'
      path: '/devices/$id'
      fullPath: '/devices/$id'
      preLoaderRoute: typeof DashboardDevicesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/certifications/$id': {
      id: '/_dashboard/certifications/$id'
      path: '/certifications/$id'
      fullPath: '/certifications/$id'
      preLoaderRoute: typeof DashboardCertificationsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reports/schedules/': {
      id: '/_dashboard/reports/schedules/'
      path: '/reports/schedules'
      fullPath: '/reports/schedules/'
      preLoaderRoute: typeof DashboardReportsSchedulesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/laboratories/$id/': {
      id: '/_dashboard/laboratories/$id/'
      path: '/'
      fullPath: '/laboratories/$id/'
      preLoaderRoute: typeof DashboardLaboratoriesIdIndexRouteImport
      parentRoute: typeof DashboardLaboratoriesIdRoute
    }
    '/_dashboard/institutions/$id/': {
      id: '/_dashboard/institutions/$id/'
      path: '/'
      fullPath: '/institutions/$id/'
      preLoaderRoute: typeof DashboardInstitutionsIdIndexRouteImport
      parentRoute: typeof DashboardInstitutionsIdRoute
    }
    '/_dashboard/installer/jobs/': {
      id: '/_dashboard/installer/jobs/'
      path: '/installer/jobs'
      fullPath: '/installer/jobs/'
      preLoaderRoute: typeof DashboardInstallerJobsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installations/$id/': {
      id: '/_dashboard/installations/$id/'
      path: '/'
      fullPath: '/installations/$id/'
      preLoaderRoute: typeof DashboardInstallationsIdIndexRouteImport
      parentRoute: typeof DashboardInstallationsIdRoute
    }
    '/_dashboard/groups/$id/': {
      id: '/_dashboard/groups/$id/'
      path: '/'
      fullPath: '/groups/$id/'
      preLoaderRoute: typeof DashboardGroupsIdIndexRouteImport
      parentRoute: typeof DashboardGroupsIdRoute
    }
    '/_dashboard/devices/$id/': {
      id: '/_dashboard/devices/$id/'
      path: '/'
      fullPath: '/devices/$id/'
      preLoaderRoute: typeof DashboardDevicesIdIndexRouteImport
      parentRoute: typeof DashboardDevicesIdRoute
    }
    '/_dashboard/certifications/$id/': {
      id: '/_dashboard/certifications/$id/'
      path: '/'
      fullPath: '/certifications/$id/'
      preLoaderRoute: typeof DashboardCertificationsIdIndexRouteImport
      parentRoute: typeof DashboardCertificationsIdRoute
    }
    '/_dashboard/users/new/$tenantId': {
      id: '/_dashboard/users/new/$tenantId'
      path: '/users/new/$tenantId'
      fullPath: '/users/new/$tenantId'
      preLoaderRoute: typeof DashboardUsersNewTenantIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/users/import/$tenantId': {
      id: '/_dashboard/users/import/$tenantId'
      path: '/users/import/$tenantId'
      fullPath: '/users/import/$tenantId'
      preLoaderRoute: typeof DashboardUsersImportTenantIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/users/$id/$tenantId': {
      id: '/_dashboard/users/$id/$tenantId'
      path: '/users/$id/$tenantId'
      fullPath: '/users/$id/$tenantId'
      preLoaderRoute: typeof DashboardUsersIdTenantIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/laboratories/$id/edit': {
      id: '/_dashboard/laboratories/$id/edit'
      path: '/edit'
      fullPath: '/laboratories/$id/edit'
      preLoaderRoute: typeof DashboardLaboratoriesIdEditRouteImport
      parentRoute: typeof DashboardLaboratoriesIdRoute
    }
    '/_dashboard/institutions/$id/storage': {
      id: '/_dashboard/institutions/$id/storage'
      path: '/storage'
      fullPath: '/institutions/$id/storage'
      preLoaderRoute: typeof DashboardInstitutionsIdStorageRouteImport
      parentRoute: typeof DashboardInstitutionsIdRoute
    }
    '/_dashboard/institutions/$id/edit': {
      id: '/_dashboard/institutions/$id/edit'
      path: '/edit'
      fullPath: '/institutions/$id/edit'
      preLoaderRoute: typeof DashboardInstitutionsIdEditRouteImport
      parentRoute: typeof DashboardInstitutionsIdRoute
    }
    '/_dashboard/installer/jobs/$id': {
      id: '/_dashboard/installer/jobs/$id'
      path: '/installer/jobs/$id'
      fullPath: '/installer/jobs/$id'
      preLoaderRoute: typeof DashboardInstallerJobsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installer/installations/$id': {
      id: '/_dashboard/installer/installations/$id'
      path: '/installer/installations/$id'
      fullPath: '/installer/installations/$id'
      preLoaderRoute: typeof DashboardInstallerInstallationsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installations/$id/edit': {
      id: '/_dashboard/installations/$id/edit'
      path: '/edit'
      fullPath: '/installations/$id/edit'
      preLoaderRoute: typeof DashboardInstallationsIdEditRouteImport
      parentRoute: typeof DashboardInstallationsIdRoute
    }
    '/_dashboard/groups/$id/edit': {
      id: '/_dashboard/groups/$id/edit'
      path: '/edit'
      fullPath: '/groups/$id/edit'
      preLoaderRoute: typeof DashboardGroupsIdEditRouteImport
      parentRoute: typeof DashboardGroupsIdRoute
    }
    '/_dashboard/devices/$id/edit': {
      id: '/_dashboard/devices/$id/edit'
      path: '/edit'
      fullPath: '/devices/$id/edit'
      preLoaderRoute: typeof DashboardDevicesIdEditRouteImport
      parentRoute: typeof DashboardDevicesIdRoute
    }
    '/_dashboard/certifications/$id/edit': {
      id: '/_dashboard/certifications/$id/edit'
      path: '/edit'
      fullPath: '/certifications/$id/edit'
      preLoaderRoute: typeof DashboardCertificationsIdEditRouteImport
      parentRoute: typeof DashboardCertificationsIdRoute
    }
    '/_dashboard/users/$id/$tenantId/': {
      id: '/_dashboard/users/$id/$tenantId/'
      path: '/'
      fullPath: '/users/$id/$tenantId/'
      preLoaderRoute: typeof DashboardUsersIdTenantIdIndexRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
    '/_dashboard/installer/installations/$id/': {
      id: '/_dashboard/installer/installations/$id/'
      path: '/'
      fullPath: '/installer/installations/$id/'
      preLoaderRoute: typeof DashboardInstallerInstallationsIdIndexRouteImport
      parentRoute: typeof DashboardInstallerInstallationsIdRoute
    }
    '/_dashboard/users/$id/$tenantId/permissions': {
      id: '/_dashboard/users/$id/$tenantId/permissions'
      path: '/permissions'
      fullPath: '/users/$id/$tenantId/permissions'
      preLoaderRoute: typeof DashboardUsersIdTenantIdPermissionsRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
    '/_dashboard/users/$id/$tenantId/move': {
      id: '/_dashboard/users/$id/$tenantId/move'
      path: '/move'
      fullPath: '/users/$id/$tenantId/move'
      preLoaderRoute: typeof DashboardUsersIdTenantIdMoveRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
    '/_dashboard/users/$id/$tenantId/edit': {
      id: '/_dashboard/users/$id/$tenantId/edit'
      path: '/edit'
      fullPath: '/users/$id/$tenantId/edit'
      preLoaderRoute: typeof DashboardUsersIdTenantIdEditRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
    '/_dashboard/users/$id/$tenantId/certifications': {
      id: '/_dashboard/users/$id/$tenantId/certifications'
      path: '/certifications'
      fullPath: '/users/$id/$tenantId/certifications'
      preLoaderRoute: typeof DashboardUsersIdTenantIdCertificationsRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
    '/_dashboard/reports/schedules/$id/edit': {
      id: '/_dashboard/reports/schedules/$id/edit'
      path: '/reports/schedules/$id/edit'
      fullPath: '/reports/schedules/$id/edit'
      preLoaderRoute: typeof DashboardReportsSchedulesIdEditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/installer/installations/$id/sensor-verification': {
      id: '/_dashboard/installer/installations/$id/sensor-verification'
      path: '/sensor-verification'
      fullPath: '/installer/installations/$id/sensor-verification'
      preLoaderRoute: typeof DashboardInstallerInstallationsIdSensorVerificationRouteImport
      parentRoute: typeof DashboardInstallerInstallationsIdRoute
    }
    '/_dashboard/installer/installations/$id/registration': {
      id: '/_dashboard/installer/installations/$id/registration'
      path: '/registration'
      fullPath: '/installer/installations/$id/registration'
      preLoaderRoute: typeof DashboardInstallerInstallationsIdRegistrationRouteImport
      parentRoute: typeof DashboardInstallerInstallationsIdRoute
    }
    '/_dashboard/installer/installations/$id/checklist': {
      id: '/_dashboard/installer/installations/$id/checklist'
      path: '/checklist'
      fullPath: '/installer/installations/$id/checklist'
      preLoaderRoute: typeof DashboardInstallerInstallationsIdChecklistRouteImport
      parentRoute: typeof DashboardInstallerInstallationsIdRoute
    }
    '/_dashboard/installer/installations/$id/calibration': {
      id: '/_dashboard/installer/installations/$id/calibration'
      path: '/calibration'
      fullPath: '/installer/installations/$id/calibration'
      preLoaderRoute: typeof DashboardInstallerInstallationsIdCalibrationRouteImport
      parentRoute: typeof DashboardInstallerInstallationsIdRoute
    }
    '/_dashboard/installer/installations/$id/airflow-monitor-test': {
      id: '/_dashboard/installer/installations/$id/airflow-monitor-test'
      path: '/airflow-monitor-test'
      fullPath: '/installer/installations/$id/airflow-monitor-test'
      preLoaderRoute: typeof DashboardInstallerInstallationsIdAirflowMonitorTestRouteImport
      parentRoute: typeof DashboardInstallerInstallationsIdRoute
    }
    '/_dashboard/users/$id/$tenantId/access/': {
      id: '/_dashboard/users/$id/$tenantId/access/'
      path: '/access'
      fullPath: '/users/$id/$tenantId/access/'
      preLoaderRoute: typeof DashboardUsersIdTenantIdAccessIndexRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
    '/_dashboard/users/$id/$tenantId/access/new': {
      id: '/_dashboard/users/$id/$tenantId/access/new'
      path: '/access/new'
      fullPath: '/users/$id/$tenantId/access/new'
      preLoaderRoute: typeof DashboardUsersIdTenantIdAccessNewRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
    '/_dashboard/users/$id/$tenantId/access/$grantId/edit': {
      id: '/_dashboard/users/$id/$tenantId/access/$grantId/edit'
      path: '/access/$grantId/edit'
      fullPath: '/users/$id/$tenantId/access/$grantId/edit'
      preLoaderRoute: typeof DashboardUsersIdTenantIdAccessGrantIdEditRouteImport
      parentRoute: typeof DashboardUsersIdTenantIdRoute
    }
  }
}

interface DashboardCertificationsIdRouteChildren {
  DashboardCertificationsIdEditRoute: typeof DashboardCertificationsIdEditRoute
  DashboardCertificationsIdIndexRoute: typeof DashboardCertificationsIdIndexRoute
}

const DashboardCertificationsIdRouteChildren: DashboardCertificationsIdRouteChildren =
  {
    DashboardCertificationsIdEditRoute: DashboardCertificationsIdEditRoute,
    DashboardCertificationsIdIndexRoute: DashboardCertificationsIdIndexRoute,
  }

const DashboardCertificationsIdRouteWithChildren =
  DashboardCertificationsIdRoute._addFileChildren(
    DashboardCertificationsIdRouteChildren,
  )

interface DashboardDevicesIdRouteChildren {
  DashboardDevicesIdEditRoute: typeof DashboardDevicesIdEditRoute
  DashboardDevicesIdIndexRoute: typeof DashboardDevicesIdIndexRoute
}

const DashboardDevicesIdRouteChildren: DashboardDevicesIdRouteChildren = {
  DashboardDevicesIdEditRoute: DashboardDevicesIdEditRoute,
  DashboardDevicesIdIndexRoute: DashboardDevicesIdIndexRoute,
}

const DashboardDevicesIdRouteWithChildren =
  DashboardDevicesIdRoute._addFileChildren(DashboardDevicesIdRouteChildren)

interface DashboardGroupsIdRouteChildren {
  DashboardGroupsIdEditRoute: typeof DashboardGroupsIdEditRoute
  DashboardGroupsIdIndexRoute: typeof DashboardGroupsIdIndexRoute
}

const DashboardGroupsIdRouteChildren: DashboardGroupsIdRouteChildren = {
  DashboardGroupsIdEditRoute: DashboardGroupsIdEditRoute,
  DashboardGroupsIdIndexRoute: DashboardGroupsIdIndexRoute,
}

const DashboardGroupsIdRouteWithChildren =
  DashboardGroupsIdRoute._addFileChildren(DashboardGroupsIdRouteChildren)

interface DashboardInstallationsIdRouteChildren {
  DashboardInstallationsIdEditRoute: typeof DashboardInstallationsIdEditRoute
  DashboardInstallationsIdIndexRoute: typeof DashboardInstallationsIdIndexRoute
}

const DashboardInstallationsIdRouteChildren: DashboardInstallationsIdRouteChildren =
  {
    DashboardInstallationsIdEditRoute: DashboardInstallationsIdEditRoute,
    DashboardInstallationsIdIndexRoute: DashboardInstallationsIdIndexRoute,
  }

const DashboardInstallationsIdRouteWithChildren =
  DashboardInstallationsIdRoute._addFileChildren(
    DashboardInstallationsIdRouteChildren,
  )

interface DashboardInstitutionsIdRouteChildren {
  DashboardInstitutionsIdEditRoute: typeof DashboardInstitutionsIdEditRoute
  DashboardInstitutionsIdStorageRoute: typeof DashboardInstitutionsIdStorageRoute
  DashboardInstitutionsIdIndexRoute: typeof DashboardInstitutionsIdIndexRoute
}

const DashboardInstitutionsIdRouteChildren: DashboardInstitutionsIdRouteChildren =
  {
    DashboardInstitutionsIdEditRoute: DashboardInstitutionsIdEditRoute,
    DashboardInstitutionsIdStorageRoute: DashboardInstitutionsIdStorageRoute,
    DashboardInstitutionsIdIndexRoute: DashboardInstitutionsIdIndexRoute,
  }

const DashboardInstitutionsIdRouteWithChildren =
  DashboardInstitutionsIdRoute._addFileChildren(
    DashboardInstitutionsIdRouteChildren,
  )

interface DashboardLaboratoriesIdRouteChildren {
  DashboardLaboratoriesIdEditRoute: typeof DashboardLaboratoriesIdEditRoute
  DashboardLaboratoriesIdIndexRoute: typeof DashboardLaboratoriesIdIndexRoute
}

const DashboardLaboratoriesIdRouteChildren: DashboardLaboratoriesIdRouteChildren =
  {
    DashboardLaboratoriesIdEditRoute: DashboardLaboratoriesIdEditRoute,
    DashboardLaboratoriesIdIndexRoute: DashboardLaboratoriesIdIndexRoute,
  }

const DashboardLaboratoriesIdRouteWithChildren =
  DashboardLaboratoriesIdRoute._addFileChildren(
    DashboardLaboratoriesIdRouteChildren,
  )

interface DashboardInstallerInstallationsIdRouteChildren {
  DashboardInstallerInstallationsIdAirflowMonitorTestRoute: typeof DashboardInstallerInstallationsIdAirflowMonitorTestRoute
  DashboardInstallerInstallationsIdCalibrationRoute: typeof DashboardInstallerInstallationsIdCalibrationRoute
  DashboardInstallerInstallationsIdChecklistRoute: typeof DashboardInstallerInstallationsIdChecklistRoute
  DashboardInstallerInstallationsIdRegistrationRoute: typeof DashboardInstallerInstallationsIdRegistrationRoute
  DashboardInstallerInstallationsIdSensorVerificationRoute: typeof DashboardInstallerInstallationsIdSensorVerificationRoute
  DashboardInstallerInstallationsIdIndexRoute: typeof DashboardInstallerInstallationsIdIndexRoute
}

const DashboardInstallerInstallationsIdRouteChildren: DashboardInstallerInstallationsIdRouteChildren =
  {
    DashboardInstallerInstallationsIdAirflowMonitorTestRoute:
      DashboardInstallerInstallationsIdAirflowMonitorTestRoute,
    DashboardInstallerInstallationsIdCalibrationRoute:
      DashboardInstallerInstallationsIdCalibrationRoute,
    DashboardInstallerInstallationsIdChecklistRoute:
      DashboardInstallerInstallationsIdChecklistRoute,
    DashboardInstallerInstallationsIdRegistrationRoute:
      DashboardInstallerInstallationsIdRegistrationRoute,
    DashboardInstallerInstallationsIdSensorVerificationRoute:
      DashboardInstallerInstallationsIdSensorVerificationRoute,
    DashboardInstallerInstallationsIdIndexRoute:
      DashboardInstallerInstallationsIdIndexRoute,
  }

const DashboardInstallerInstallationsIdRouteWithChildren =
  DashboardInstallerInstallationsIdRoute._addFileChildren(
    DashboardInstallerInstallationsIdRouteChildren,
  )

interface DashboardUsersIdTenantIdRouteChildren {
  DashboardUsersIdTenantIdCertificationsRoute: typeof DashboardUsersIdTenantIdCertificationsRoute
  DashboardUsersIdTenantIdEditRoute: typeof DashboardUsersIdTenantIdEditRoute
  DashboardUsersIdTenantIdMoveRoute: typeof DashboardUsersIdTenantIdMoveRoute
  DashboardUsersIdTenantIdPermissionsRoute: typeof DashboardUsersIdTenantIdPermissionsRoute
  DashboardUsersIdTenantIdIndexRoute: typeof DashboardUsersIdTenantIdIndexRoute
  DashboardUsersIdTenantIdAccessNewRoute: typeof DashboardUsersIdTenantIdAccessNewRoute
  DashboardUsersIdTenantIdAccessIndexRoute: typeof DashboardUsersIdTenantIdAccessIndexRoute
  DashboardUsersIdTenantIdAccessGrantIdEditRoute: typeof DashboardUsersIdTenantIdAccessGrantIdEditRoute
}

const DashboardUsersIdTenantIdRouteChildren: DashboardUsersIdTenantIdRouteChildren =
  {
    DashboardUsersIdTenantIdCertificationsRoute:
      DashboardUsersIdTenantIdCertificationsRoute,
    DashboardUsersIdTenantIdEditRoute: DashboardUsersIdTenantIdEditRoute,
    DashboardUsersIdTenantIdMoveRoute: DashboardUsersIdTenantIdMoveRoute,
    DashboardUsersIdTenantIdPermissionsRoute:
      DashboardUsersIdTenantIdPermissionsRoute,
    DashboardUsersIdTenantIdIndexRoute: DashboardUsersIdTenantIdIndexRoute,
    DashboardUsersIdTenantIdAccessNewRoute:
      DashboardUsersIdTenantIdAccessNewRoute,
    DashboardUsersIdTenantIdAccessIndexRoute:
      DashboardUsersIdTenantIdAccessIndexRoute,
    DashboardUsersIdTenantIdAccessGrantIdEditRoute:
      DashboardUsersIdTenantIdAccessGrantIdEditRoute,
  }

const DashboardUsersIdTenantIdRouteWithChildren =
  DashboardUsersIdTenantIdRoute._addFileChildren(
    DashboardUsersIdTenantIdRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardSplatRoute: typeof DashboardSplatRoute
  DashboardDashboardRoute: typeof DashboardDashboardRoute
  DashboardForbiddenRoute: typeof DashboardForbiddenRoute
  DashboardLogsRoute: typeof DashboardLogsRoute
  DashboardNotificationsRoute: typeof DashboardNotificationsRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardCertificationsIdRoute: typeof DashboardCertificationsIdRouteWithChildren
  DashboardDevicesIdRoute: typeof DashboardDevicesIdRouteWithChildren
  DashboardDevicesNewRoute: typeof DashboardDevicesNewRoute
  DashboardGroupsIdRoute: typeof DashboardGroupsIdRouteWithChildren
  DashboardGroupsNewRoute: typeof DashboardGroupsNewRoute
  DashboardInstallationsIdRoute: typeof DashboardInstallationsIdRouteWithChildren
  DashboardInstallationsNewRoute: typeof DashboardInstallationsNewRoute
  DashboardInstitutesSplatRoute: typeof DashboardInstitutesSplatRoute
  DashboardInstitutionsIdRoute: typeof DashboardInstitutionsIdRouteWithChildren
  DashboardInstitutionsNewRoute: typeof DashboardInstitutionsNewRoute
  DashboardLaboratoriesIdRoute: typeof DashboardLaboratoriesIdRouteWithChildren
  DashboardLaboratoriesNewRoute: typeof DashboardLaboratoriesNewRoute
  DashboardReportsIdRoute: typeof DashboardReportsIdRoute
  DashboardReportsNewRoute: typeof DashboardReportsNewRoute
  DashboardRequestsIdRoute: typeof DashboardRequestsIdRoute
  DashboardRfidTagsNewRoute: typeof DashboardRfidTagsNewRoute
  DashboardStreamsSessionIdRoute: typeof DashboardStreamsSessionIdRoute
  DashboardCertificationsIndexRoute: typeof DashboardCertificationsIndexRoute
  DashboardDevicesIndexRoute: typeof DashboardDevicesIndexRoute
  DashboardGroupsIndexRoute: typeof DashboardGroupsIndexRoute
  DashboardInstallationsIndexRoute: typeof DashboardInstallationsIndexRoute
  DashboardInstallerIndexRoute: typeof DashboardInstallerIndexRoute
  DashboardInstitutesIndexRoute: typeof DashboardInstitutesIndexRoute
  DashboardInstitutionsIndexRoute: typeof DashboardInstitutionsIndexRoute
  DashboardLaboratoriesIndexRoute: typeof DashboardLaboratoriesIndexRoute
  DashboardReportsIndexRoute: typeof DashboardReportsIndexRoute
  DashboardRequestsIndexRoute: typeof DashboardRequestsIndexRoute
  DashboardRfidTagsIndexRoute: typeof DashboardRfidTagsIndexRoute
  DashboardStreamsIndexRoute: typeof DashboardStreamsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardInstallerInstallationsIdRoute: typeof DashboardInstallerInstallationsIdRouteWithChildren
  DashboardInstallerJobsIdRoute: typeof DashboardInstallerJobsIdRoute
  DashboardUsersIdTenantIdRoute: typeof DashboardUsersIdTenantIdRouteWithChildren
  DashboardUsersImportTenantIdRoute: typeof DashboardUsersImportTenantIdRoute
  DashboardUsersNewTenantIdRoute: typeof DashboardUsersNewTenantIdRoute
  DashboardInstallerJobsIndexRoute: typeof DashboardInstallerJobsIndexRoute
  DashboardReportsSchedulesIndexRoute: typeof DashboardReportsSchedulesIndexRoute
  DashboardReportsSchedulesIdEditRoute: typeof DashboardReportsSchedulesIdEditRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardSplatRoute: DashboardSplatRoute,
  DashboardDashboardRoute: DashboardDashboardRoute,
  DashboardForbiddenRoute: DashboardForbiddenRoute,
  DashboardLogsRoute: DashboardLogsRoute,
  DashboardNotificationsRoute: DashboardNotificationsRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardCertificationsIdRoute: DashboardCertificationsIdRouteWithChildren,
  DashboardDevicesIdRoute: DashboardDevicesIdRouteWithChildren,
  DashboardDevicesNewRoute: DashboardDevicesNewRoute,
  DashboardGroupsIdRoute: DashboardGroupsIdRouteWithChildren,
  DashboardGroupsNewRoute: DashboardGroupsNewRoute,
  DashboardInstallationsIdRoute: DashboardInstallationsIdRouteWithChildren,
  DashboardInstallationsNewRoute: DashboardInstallationsNewRoute,
  DashboardInstitutesSplatRoute: DashboardInstitutesSplatRoute,
  DashboardInstitutionsIdRoute: DashboardInstitutionsIdRouteWithChildren,
  DashboardInstitutionsNewRoute: DashboardInstitutionsNewRoute,
  DashboardLaboratoriesIdRoute: DashboardLaboratoriesIdRouteWithChildren,
  DashboardLaboratoriesNewRoute: DashboardLaboratoriesNewRoute,
  DashboardReportsIdRoute: DashboardReportsIdRoute,
  DashboardReportsNewRoute: DashboardReportsNewRoute,
  DashboardRequestsIdRoute: DashboardRequestsIdRoute,
  DashboardRfidTagsNewRoute: DashboardRfidTagsNewRoute,
  DashboardStreamsSessionIdRoute: DashboardStreamsSessionIdRoute,
  DashboardCertificationsIndexRoute: DashboardCertificationsIndexRoute,
  DashboardDevicesIndexRoute: DashboardDevicesIndexRoute,
  DashboardGroupsIndexRoute: DashboardGroupsIndexRoute,
  DashboardInstallationsIndexRoute: DashboardInstallationsIndexRoute,
  DashboardInstallerIndexRoute: DashboardInstallerIndexRoute,
  DashboardInstitutesIndexRoute: DashboardInstitutesIndexRoute,
  DashboardInstitutionsIndexRoute: DashboardInstitutionsIndexRoute,
  DashboardLaboratoriesIndexRoute: DashboardLaboratoriesIndexRoute,
  DashboardReportsIndexRoute: DashboardReportsIndexRoute,
  DashboardRequestsIndexRoute: DashboardRequestsIndexRoute,
  DashboardRfidTagsIndexRoute: DashboardRfidTagsIndexRoute,
  DashboardStreamsIndexRoute: DashboardStreamsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardInstallerInstallationsIdRoute:
    DashboardInstallerInstallationsIdRouteWithChildren,
  DashboardInstallerJobsIdRoute: DashboardInstallerJobsIdRoute,
  DashboardUsersIdTenantIdRoute: DashboardUsersIdTenantIdRouteWithChildren,
  DashboardUsersImportTenantIdRoute: DashboardUsersImportTenantIdRoute,
  DashboardUsersNewTenantIdRoute: DashboardUsersNewTenantIdRoute,
  DashboardInstallerJobsIndexRoute: DashboardInstallerJobsIndexRoute,
  DashboardReportsSchedulesIndexRoute: DashboardReportsSchedulesIndexRoute,
  DashboardReportsSchedulesIdEditRoute: DashboardReportsSchedulesIdEditRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  DeviceRegistrationRoute: DeviceRegistrationRoute,
  LoginRoute: LoginRoute,
  RfidAssignmentRoute: RfidAssignmentRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
